import * as React from 'react';
import * as styles from '../Analytics.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { IADetailsList } from '../detailsList/DetailsList';
import AnalyticsService from '../../../services/AnalyticsService';
import { IADropDown } from '../../dropDown/DropDown';
import { inject, observer} from 'mobx-react';
import { AnalyticsStore } from '../stores';
import { IADateAndTimePicker } from '../../dateAndTimePicker/DateAndTimePicker';
import { IAIcon } from '../../icon/Icon';
import { LoggingService } from '../../../services/LoggingService';
import "../../../styles/BasicIA.css";
import CountUp from 'react-countup';
import { IMobileDevicesAnalytics } from '../../../interfaces/IMobileDevicesAnalytics';
import Chart from 'react-google-charts';

export interface IProps {
  analyticsStore?: AnalyticsStore;
}

@inject('analyticsStore')
@observer
export class MobileDevicesTab extends React.Component<IProps> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    LoggingService.init(this.props.analyticsStore.environment);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.getContent();
  }

  private getContent(): void {
    this.props.analyticsStore.mobileDevicesRows = undefined;
    AnalyticsService.getRegisteredMobileDevices(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, this.props.analyticsStore.mobileDevicesFromDate.toDateString(), this.props.analyticsStore.mobileDevicesToDate.toDateString()).then((result: IMobileDevicesAnalytics[]) => {
      this.props.analyticsStore.mobileDevicesResult = result;
      this.props.analyticsStore.mobileDevicesResult = this.props.analyticsStore.sortMobileDevices();
      let totalDevices = 0;
      let userRegistrations = 0;
      let userUnRegistrations = 0;
      this.props.analyticsStore.mobileDevicesResult.forEach((registeredDevice: IMobileDevicesAnalytics) => {
        totalDevices += registeredDevice.devices;
        if (registeredDevice.devices > 0)
            userRegistrations++
        else userUnRegistrations++
          });      
      this.props.analyticsStore.totalMobileDevicesRegistered = totalDevices;
      this.props.analyticsStore.totalUserRegistrations = userRegistrations
      this.props.analyticsStore.totalUserUnRegistrations = userUnRegistrations
      this.showResult();
    });
  }
 
  private showResult(): void {
    let rows = [];
     this.props.analyticsStore.mobileDevicesResult.forEach((row: IMobileDevicesAnalytics, index: number) => {
      rows.push(
        <tr key={index}>
          <td
            className={"IA_OnFocus"}
            tabIndex={0}
            onClick={() => {
              // Clicked email implementation gose here 
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
              // key pressed email implementation gose here 
              }
            }}
            style={{
              width: "40%",
              backgroundColor: this.props.analyticsStore.mobileDevicesSortProperty === "email" ? "#f5f5f5" : "transparent",
              color: this.props.analyticsStore.highlightColor,
              cursor: "pointer"
            }}
          >
            {row.email}
          </td>
          <td style={{ width: "12%", textAlign: "center", backgroundColor: this.props.analyticsStore.mobileDevicesSortProperty === "devices" ? "#f5f5f5" : "transparent" }}>{row.devices}</td>
          <td style={{ width: "14%", minWidth: "14%" }}>
          </td>
        </tr>
      );
    });
    this.props.analyticsStore.mobileDevicesRows = rows;
  }

  private setPeriodeFilter(): void {
    switch (this.props.analyticsStore.mobileDevicesPeriodeFilter) {
      case "today":
        this.props.analyticsStore.mobileDevicesFromDate = new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.mobileDevicesToDate = new Date();
        break;
      case "latestWeek":
        this.props.analyticsStore.mobileDevicesFromDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.mobileDevicesToDate = new Date();
        break;
      case "latestMonth":
        this.props.analyticsStore.mobileDevicesFromDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.mobileDevicesToDate = new Date();
        break;
      default:
        this.props.analyticsStore.mobileDevicesFromDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.mobileDevicesToDate = new Date();
        break;
    }
    this.getContent();
  }

  private sortBy(propertyToSortBy: "email" | "devices") {
    if (this.props.analyticsStore.mobileDevicesSortProperty !== propertyToSortBy) {
      this.props.analyticsStore.mobileDevicesSortProperty = propertyToSortBy;
      this.props.analyticsStore.mobileDevicesResult = this.props.analyticsStore.sortMobileDevices();
    }
    else {
      this.props.analyticsStore.mobileDevicesResult = this.props.analyticsStore.mobileDevicesResult.reverse();
    }
    this.showResult();
  }

  public render(): JSX.Element {
    return (
      <div className={styles.IA_analytics}>
        <div
          tabIndex={0}
          className={[styles.IA_topView, "IA_OnFocus"].join(" ")}
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            // clicked total regiistered devices box implementation gose here
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
            // key pressed total regiistered devices box implementation gose here
            }
          }}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.totalMobileDevicesRegistered ?
              <CountUp
                start={0}
                end={this.props.analyticsStore.totalMobileDevicesRegistered}
                duration={2}
              />
              :
              0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_TotalRegistredMobileDevices}
            </div>
          </div>
        </div>
        <div
          className={styles.IA_topView}
        >
          <div style={{
            fontSize: 30,
            marginTop: -20,
            marginLeft: -40
          }}>
            {this.props.analyticsStore.totalUniqueWebViews != undefined && this.props.analyticsStore.totalUniqueMobileViews != undefined &&
              <Chart
                width={250}
                height={120}
                chartType="PieChart"
                loader={<div></div>}
                data={[
                  ['Language', this.localizationService.strings.Analytics_MessageUniqueViewsSource],
                  [this.localizationService.strings.Analytics_UnRegisteredUsers, this.props.analyticsStore.totalUserUnRegistrations],
                  [this.localizationService.strings.Analytics_RegisteredUsers, this.props.analyticsStore.totalUserRegistrations]
                ]}
                options={{
                  colors: ["#23879b", "#50b9ce"],
                  backgroundColor: "transparent",
                  animation: {
                    startup: true,
                    easing: 'linear',
                    duration: 1500,
                  },
                  pieStartAngle: 100,
                }}
                chartEvents={[
                  {
                    eventName: 'animationfinish',
                    callback: () => {
                      console.log('Animation Finished')
                    },
                  },
                ]}
                rootProps={{ 'data-testid': '4' }}
              />
            }
          </div>
          <div className={styles.IA_topViewLabel}>
            {this.localizationService.strings.Analytics_RegisteredUsersAndUnRegisteredUsers}
          </div>
        </div>
        <div className = {styles.IA_topView_description}>     
          <p> {this.localizationService.strings.Analytics_RegisteredUsersDescribtionLine1} </p> 
          <p> {this.localizationService.strings.Analytics_RegisteredUsersDescribtionLine2} </p>  
          <p> {this.localizationService.strings.Analytics_RegisteredUsersDescribtionLine3} </p> 
          <br/>
          <p> {this.localizationService.strings.Analytics_RegisteredUsersDescribtionLine4} </p> 
          <p> {this.localizationService.strings.Analytics_RegisteredUsersDescribtionLine5} </p>
        </div>
        <div className={styles.IA_filter}>
          <div style={{ float: "left", clear: "both", marginRight: 20 }}>
            <IADropDown
              label={this.localizationService.strings.Analytics_Period}
              selectedOption={this.props.analyticsStore.mobileDevicesPeriodeFilter}
              options={[
                {
                  key: "today",
                  value: this.localizationService.strings.Analytics_LatestDay
                },
                {
                  key: "latestWeek",
                  value: this.localizationService.strings.Analytics_LatestWeek
                },
                {
                  key: "latestMonth",
                  value: this.localizationService.strings.Analytics_LatestMonth
                }
              ]}
              onChange={(periodeFilter) => {
                if (periodeFilter !== this.props.analyticsStore.mobileDevicesPeriodeFilter) {
                  this.props.analyticsStore.mobileDevicesPeriodeFilter = periodeFilter;
                  this.setPeriodeFilter();
                }
              }}
              style={{
                float: "left",
                width: 405
              }}
            />
            {this.props.analyticsStore.mobileDevicesPeriodeFilter === "customPeriode" &&
              <div style={{ float: "left", clear: "both" }}>
                <div style={{ float: "left", width: 168 }}>
                  <IADateAndTimePicker
                    selectedDate={this.props.analyticsStore.mobileDevicesFromDate}
                    showTimeSelector={false}
                    highlightColor={this.props.analyticsStore.highlightColor}
                    isClearable={false}
                    onChange={(fromDate: Date) => {
                      this.props.analyticsStore.mobileDevicesFromDate = fromDate;
                      this.getContent();
                    }}
                    style={{
                      width: 168,
                      marginTop: 0,
                      float: "left"
                    }}
                  />
                </div>
                <IAIcon
                  title={"Next"}
                  size={18}
                  color={"#777777"}
                  style={{
                    float: "left",
                    margin: "20px 10px"

                  }}
                />
                <div style={{ float: "left", width: 168 }}>
                  <IADateAndTimePicker
                    selectedDate={this.props.analyticsStore.mobileDevicesToDate}
                    showTimeSelector={false}
                    highlightColor={this.props.analyticsStore.highlightColor}
                    isClearable={false}
                    onChange={(toDate: Date) => {
                      this.props.analyticsStore.mobileDevicesToDate = toDate;
                      this.getContent();
                    }}
                    style={{
                      width: 168,
                      marginTop: 0,
                      float: "left"
                    }}
                  />
                </div>
              </div>
            }
          </div>
        </div>
        <div className={styles.IA_detailsListContainer}>
          <IADetailsList
            columnHeadlines={[
              <th
                key={"columnHeadline_1"}
                className="IA_OnFocus"
                style={{
                  backgroundColor: this.props.analyticsStore.mobileDevicesSortProperty === "email" ? "#f5f5f5" : "transparent",
                  cursor: "pointer",
                  color: this.props.analyticsStore.highlightColor
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("email");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("email");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_Email}
              </th>,
              <th
                key={"columnHeadline_2"}
                className="IA_OnFocus"
                style={{
                  backgroundColor: this.props.analyticsStore.mobileDevicesSortProperty === "devices" ? "#f5f5f5" : "transparent",
                  cursor: "pointer", color: this.props.analyticsStore.highlightColor,
                  textAlign: "center"
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("devices");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("devices");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_RegisteredMobileDevices}
              </th>
            ]}
            rows={this.props.analyticsStore.mobileDevicesRows}
          />
        </div>
        {this.props.analyticsStore.loading &&
          <div
            className={styles.IA_loading}
          >
            <div className={styles.loader}></div>
          </div>
        }
      </div>
    );
  }

  
}